"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpcRating$ = exports.EpcRating$outboundSchema = exports.EpcRating$inboundSchema = void 0;
exports.epcRatingToJSON = epcRatingToJSON;
exports.epcRatingFromJSON = epcRatingFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const energyefficiency_js_1 = require("./energyefficiency.js");
const environmentalimpact_js_1 = require("./environmentalimpact.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.EpcRating$inboundSchema = z.object({
    address1: z.nullable(z.string()),
    address2: z.nullable(z.string()),
    address3: z.nullable(z.string()),
    built_form: z.nullable(z.string()),
    energy_efficiency: z.nullable(energyefficiency_js_1.EnergyEfficiency$inboundSchema),
    energy_tariff: z.nullable(z.string()),
    environmental_impact: environmentalimpact_js_1.EnvironmentalImpact$inboundSchema,
    expiry_date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    extension_count: z.nullable(z.number().int()),
    flat_storey_count: z.nullable(z.number().int()),
    flat_top_storey: z.nullable(z.string()),
    floor_description: z.nullable(z.string()),
    floor_energy_eff: z.nullable(z.string()),
    floor_height: z.nullable(z.number()),
    floor_level: z.nullable(z.string()),
    glazed_area: z.nullable(z.string()),
    glazed_type: z.nullable(z.string()),
    hot_water_energy_eff: z.nullable(z.string()),
    hotwater_description: z.nullable(z.string()),
    lighting_description: z.nullable(z.string()),
    lighting_energy_eff: z.nullable(z.string()),
    lmk_key: z.nullable(z.string()),
    lodgement_date: z.string(),
    main_fuel: z.nullable(z.string()),
    main_heating_controls: z.nullable(z.string()),
    mainheat_description: z.nullable(z.string()),
    mainheat_energy_eff: z.nullable(z.string()),
    mains_gas_flag: z.nullable(z.string()),
    mechanical_ventilation: z.nullable(z.string()),
    meta: z.nullable(meta_js_1.Meta$inboundSchema),
    number_habitable_rooms: z.nullable(z.number().int()),
    number_heated_rooms: z.nullable(z.number().int()),
    number_open_fireplaces: z.nullable(z.number().int()),
    postcode: z.nullable(z.string()),
    property_type: z.nullable(z.string()),
    roof_description: z.nullable(z.string()),
    roof_energy_eff: z.nullable(z.string()),
    secondheat_description: z.nullable(z.string()),
    sheating_energy_eff: z.nullable(z.string()),
    total_floor_area: z.nullable(z.number()),
    transaction_type: z.nullable(z.string()),
    walls_description: z.nullable(z.string()),
    walls_energy_eff: z.nullable(z.string()),
    wind_turbine_count: z.nullable(z.string()),
    windows_description: z.nullable(z.string()),
    windows_energy_eff: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "built_form": "builtForm",
        "energy_efficiency": "energyEfficiency",
        "energy_tariff": "energyTariff",
        "environmental_impact": "environmentalImpact",
        "expiry_date": "expiryDate",
        "extension_count": "extensionCount",
        "flat_storey_count": "flatStoreyCount",
        "flat_top_storey": "flatTopStorey",
        "floor_description": "floorDescription",
        "floor_energy_eff": "floorEnergyEff",
        "floor_height": "floorHeight",
        "floor_level": "floorLevel",
        "glazed_area": "glazedArea",
        "glazed_type": "glazedType",
        "hot_water_energy_eff": "hotWaterEnergyEff",
        "hotwater_description": "hotwaterDescription",
        "lighting_description": "lightingDescription",
        "lighting_energy_eff": "lightingEnergyEff",
        "lmk_key": "lmkKey",
        "lodgement_date": "lodgementDate",
        "main_fuel": "mainFuel",
        "main_heating_controls": "mainHeatingControls",
        "mainheat_description": "mainheatDescription",
        "mainheat_energy_eff": "mainheatEnergyEff",
        "mains_gas_flag": "mainsGasFlag",
        "mechanical_ventilation": "mechanicalVentilation",
        "number_habitable_rooms": "numberHabitableRooms",
        "number_heated_rooms": "numberHeatedRooms",
        "number_open_fireplaces": "numberOpenFireplaces",
        "property_type": "propertyType",
        "roof_description": "roofDescription",
        "roof_energy_eff": "roofEnergyEff",
        "secondheat_description": "secondheatDescription",
        "sheating_energy_eff": "sheatingEnergyEff",
        "total_floor_area": "totalFloorArea",
        "transaction_type": "transactionType",
        "walls_description": "wallsDescription",
        "walls_energy_eff": "wallsEnergyEff",
        "wind_turbine_count": "windTurbineCount",
        "windows_description": "windowsDescription",
        "windows_energy_eff": "windowsEnergyEff",
    });
});
/** @internal */
exports.EpcRating$outboundSchema = z.object({
    address1: z.nullable(z.string()),
    address2: z.nullable(z.string()),
    address3: z.nullable(z.string()),
    builtForm: z.nullable(z.string()),
    energyEfficiency: z.nullable(energyefficiency_js_1.EnergyEfficiency$outboundSchema),
    energyTariff: z.nullable(z.string()),
    environmentalImpact: environmentalimpact_js_1.EnvironmentalImpact$outboundSchema,
    expiryDate: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    extensionCount: z.nullable(z.number().int()),
    flatStoreyCount: z.nullable(z.number().int()),
    flatTopStorey: z.nullable(z.string()),
    floorDescription: z.nullable(z.string()),
    floorEnergyEff: z.nullable(z.string()),
    floorHeight: z.nullable(z.number()),
    floorLevel: z.nullable(z.string()),
    glazedArea: z.nullable(z.string()),
    glazedType: z.nullable(z.string()),
    hotWaterEnergyEff: z.nullable(z.string()),
    hotwaterDescription: z.nullable(z.string()),
    lightingDescription: z.nullable(z.string()),
    lightingEnergyEff: z.nullable(z.string()),
    lmkKey: z.nullable(z.string()),
    lodgementDate: z.string(),
    mainFuel: z.nullable(z.string()),
    mainHeatingControls: z.nullable(z.string()),
    mainheatDescription: z.nullable(z.string()),
    mainheatEnergyEff: z.nullable(z.string()),
    mainsGasFlag: z.nullable(z.string()),
    mechanicalVentilation: z.nullable(z.string()),
    meta: z.nullable(meta_js_1.Meta$outboundSchema),
    numberHabitableRooms: z.nullable(z.number().int()),
    numberHeatedRooms: z.nullable(z.number().int()),
    numberOpenFireplaces: z.nullable(z.number().int()),
    postcode: z.nullable(z.string()),
    propertyType: z.nullable(z.string()),
    roofDescription: z.nullable(z.string()),
    roofEnergyEff: z.nullable(z.string()),
    secondheatDescription: z.nullable(z.string()),
    sheatingEnergyEff: z.nullable(z.string()),
    totalFloorArea: z.nullable(z.number()),
    transactionType: z.nullable(z.string()),
    wallsDescription: z.nullable(z.string()),
    wallsEnergyEff: z.nullable(z.string()),
    windTurbineCount: z.nullable(z.string()),
    windowsDescription: z.nullable(z.string()),
    windowsEnergyEff: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        builtForm: "built_form",
        energyEfficiency: "energy_efficiency",
        energyTariff: "energy_tariff",
        environmentalImpact: "environmental_impact",
        expiryDate: "expiry_date",
        extensionCount: "extension_count",
        flatStoreyCount: "flat_storey_count",
        flatTopStorey: "flat_top_storey",
        floorDescription: "floor_description",
        floorEnergyEff: "floor_energy_eff",
        floorHeight: "floor_height",
        floorLevel: "floor_level",
        glazedArea: "glazed_area",
        glazedType: "glazed_type",
        hotWaterEnergyEff: "hot_water_energy_eff",
        hotwaterDescription: "hotwater_description",
        lightingDescription: "lighting_description",
        lightingEnergyEff: "lighting_energy_eff",
        lmkKey: "lmk_key",
        lodgementDate: "lodgement_date",
        mainFuel: "main_fuel",
        mainHeatingControls: "main_heating_controls",
        mainheatDescription: "mainheat_description",
        mainheatEnergyEff: "mainheat_energy_eff",
        mainsGasFlag: "mains_gas_flag",
        mechanicalVentilation: "mechanical_ventilation",
        numberHabitableRooms: "number_habitable_rooms",
        numberHeatedRooms: "number_heated_rooms",
        numberOpenFireplaces: "number_open_fireplaces",
        propertyType: "property_type",
        roofDescription: "roof_description",
        roofEnergyEff: "roof_energy_eff",
        secondheatDescription: "secondheat_description",
        sheatingEnergyEff: "sheating_energy_eff",
        totalFloorArea: "total_floor_area",
        transactionType: "transaction_type",
        wallsDescription: "walls_description",
        wallsEnergyEff: "walls_energy_eff",
        windTurbineCount: "wind_turbine_count",
        windowsDescription: "windows_description",
        windowsEnergyEff: "windows_energy_eff",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EpcRating$;
(function (EpcRating$) {
    /** @deprecated use `EpcRating$inboundSchema` instead. */
    EpcRating$.inboundSchema = exports.EpcRating$inboundSchema;
    /** @deprecated use `EpcRating$outboundSchema` instead. */
    EpcRating$.outboundSchema = exports.EpcRating$outboundSchema;
})(EpcRating$ || (exports.EpcRating$ = EpcRating$ = {}));
function epcRatingToJSON(epcRating) {
    return JSON.stringify(exports.EpcRating$outboundSchema.parse(epcRating));
}
function epcRatingFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EpcRating$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EpcRating' from JSON`);
}
//# sourceMappingURL=epcrating.js.map